export const operator1 = [
  {
    additionalInfo: {
      verified: true,
      instantConfirmation: true,
      payByApp: true,
    },
    _id: "65d6b639bb1369f6006dd3ee",
    name: "Saigon Star",
    email: "hello.saigonstar@gmail.com",
    password: "$2a$10$tmMyIQXtQh2KZujX3H8uF.oJgGkhzBf1NRIsrB6HynmkEVC/Kbo/m",
    isAdmin: true,
    coverPhoto:
      "https://lokalai-menu.s3.ap-southeast-2.amazonaws.com/coverbebau.png",
    photo: "https://lokalai-menu.s3.ap-southeast-2.amazonaws.com/logoBeBau.jpg",
    phone: "(+64) 3 348 8879",
    address: {
      street: "184 Clarence Street",
      suburb: "Upper Riccarton",
      city: "Christchurch",
      country: "New Zealand",
    },
    bio: "Saigon Star, a family ran Vietnamese restaurant, we have been serving Christchurch locals since 2005. Tucked in the corner of Christchurch most busiest intersection in Riccarton, there has been many great memories watching people find Saigon Star as their go to quick lunch hour destination, their weekly Vietnamese dinner fix. We are so proud & happy to be able to continue to serve the community with our new launch of our brand.",
    quote: " ",
    author: " ",
    __v: 0,
    createdAt: "2024-02-22T02:49:29.173Z",
    updatedAt: "2025-10-14T01:48:11.707Z",
    hasLoyalty: false,
    operatorType: "ordering",
    country: "New Zealand",
    profesional: ["Restaurant"],
    town: "Christchurch",
    mapLink:
      "https://www.google.com/maps?q=184+Clarence+Street+Upper+Riccarton+Christchurch",

    mapEmbed:
      "https://www.google.com/maps?q=Saigon+Star+Christchurch&output=embed",

    openingHours: [
      {
        day: "Sunday – Thursday",
        slots: [
          { open: "11:30am", close: "3:00pm" },
          { open: "5:00pm", close: "9:30pm" },
        ],
      },
      {
        day: "Friday – Saturday",
        slots: [
          { open: "11:30am", close: "3:00pm" },
          { open: "5:00pm", close: "10:00pm" },
        ],
      },
    ],
    slug: "bb-vietnamese-street-food",
    otpCode: "581524",
    otpExpire: "2025-10-14T02:48:11.705Z",
  },
];

export const menuCategory = [
  {
    _id: "65d6c0d704261474450578b9",
    name: "Entrè",
    image: "https://mira-elite.s3.ap-southeast-2.amazonaws.com/entre.webp",
    className: "bg-pink-200 h-full md:h32",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T03:34:47.079Z",
    updatedAt: "2025-02-09T18:18:47.518Z",
  },
  {
    _id: "65d6c0d704261474450578b8",
    name: "Canh - SOUP",
    image: "https://mira-elite.s3.ap-southeast-2.amazonaws.com/canh.webp",
    className: "bg-pink-200 h-full md:h32",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T03:34:47.079Z",
    updatedAt: "2024-02-22T03:34:47.079Z",
  },
  {
    _id: "65d6c0d704261474450578bc",
    name: "Gỏi - SALAD",
    image: "https://mira-elite.s3.ap-southeast-2.amazonaws.com/goi.webp",
    className: "bg-pink-200 h-full md:h32",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T03:34:47.079Z",
    updatedAt: "2024-02-22T03:34:47.079Z",
  },
  {
    _id: "65d6c0d704261474450578b7",
    name: "bún chả - RICE VERMICELLI BOWL",
    image: "https://mira-elite.s3.ap-southeast-2.amazonaws.com/buncha.webp",
    className: "bg-pink-200 h-full md:h32",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T03:34:47.079Z",
    updatedAt: "2024-02-22T03:34:47.079Z",
  },
  {
    _id: "65d6c0d704261474450578b6",
    name: "phở - VIETNAMESE RICE NOODLE SOUP",
    image: "https://mira-elite.s3.ap-southeast-2.amazonaws.com/pho.webp",
    className: "bg-pink-200 h-full md:h32",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T03:34:47.078Z",
    updatedAt: "2024-02-22T03:34:47.078Z",
  },
  {
    _id: "65d6c0d704261474450578ba",
    name: "mì/ hủ tiếu xào - STIR FRY NOODLES",
    image: "https://mira-elite.s3.ap-southeast-2.amazonaws.com/mi.webp",
    className: "bg-pink-200 h-full md:h32",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T03:34:47.079Z",
    updatedAt: "2024-02-22T03:34:47.079Z",
  },
  {
    _id: "65d6c0d704261474450578bb",
    name: "cơm phần - RICE DISHES",
    image: "https://mira-elite.s3.ap-southeast-2.amazonaws.com/comphan.webp",
    className: "bg-pink-200 h-full md:h32",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T03:34:47.079Z",
    updatedAt: "2024-02-22T03:34:47.079Z",
  },
  {
    _id: "67791248cc320ae6162019f7",
    name: "gà - CHICKEN",
    image: "https://mira-elite.s3.ap-southeast-2.amazonaws.com/ga.webp",
    className: "bg-pink-200 h-full md:h32",
    operator: "65d6b639bb1369f6006dd3ee",
    createdAt: "2025-01-04T10:49:44.966Z",
    updatedAt: "2025-01-04T10:55:17.370Z",
    __v: 0,
  },
  {
    _id: "67791248cc320ae6162019f8",
    name: "bỏ - BEEF",
    image: "https://mira-elite.s3.ap-southeast-2.amazonaws.com/bo.webp",
    className: "bg-pink-200 h-full md:h32",
    operator: "65d6b639bb1369f6006dd3ee",
    createdAt: "2025-01-04T10:49:44.966Z",
    updatedAt: "2025-01-04T10:55:17.370Z",
    __v: 0,
  },
  {
    _id: "67791248cc320ae6162019f9",
    name: "heo - PORK",
    image: "https://mira-elite.s3.ap-southeast-2.amazonaws.com/heo.webp",
    className: "bg-pink-200 h-full md:h32",
    operator: "65d6b639bb1369f6006dd3ee",
    createdAt: "2025-01-04T10:49:44.966Z",
    updatedAt: "2025-01-04T10:55:17.370Z",
    __v: 0,
  },
  {
    _id: "67791248cc320ae616201910",
    name: "hải sản - SEAFOOD",
    image: "https://mira-elite.s3.ap-southeast-2.amazonaws.com/haisan.webp",
    className: "bg-pink-200 h-full md:h32",
    operator: "65d6b639bb1369f6006dd3ee",
    createdAt: "2025-01-04T10:49:44.966Z",
    updatedAt: "2025-01-04T10:55:17.370Z",
    __v: 0,
  },
  {
    _id: "67791248cc320ae616201911",
    name: "đồ chay - VEGETABLE& TOFU DISHES",
    image: "https://mira-elite.s3.ap-southeast-2.amazonaws.com/dochay.webp",
    className: "bg-pink-200 h-full md:h32",
    operator: "65d6b639bb1369f6006dd3ee",
    createdAt: "2025-01-04T10:49:44.966Z",
    updatedAt: "2025-01-04T10:55:17.370Z",
    __v: 0,
  },
  {
    _id: "67791248cc320ae616201912",
    name: "BEVERAGE",
    image:
      "https://mira-elite.s3.ap-southeast-2.amazonaws.com/ICE_COFFEE_2_700x.webp",
    className: "bg-pink-200 h-full md:h32",
    operator: "65d6b639bb1369f6006dd3ee",
    createdAt: "2025-01-04T10:49:44.966Z",
    updatedAt: "2025-01-04T10:55:17.370Z",
    __v: 0,
  },
];

export const menuItems = [
  //entre
  {
    _id: "65d6cc558845c39895773f1b",
    title: "PRAWN & PORK FRESH SPRING ROLLS",
    price: 13.0,
    desc: "Prawn, pork, pickled salad, lettuce with rice vermicelli wrapped in rice paper with house-made peanut dipping sauce.",
    image: "https://saigonstar.s3.ap-southeast-2.amazonaws.com/springroll.webp",
    category: "65d6c0d704261474450578b9",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.850Z",
    updatedAt: "2024-02-22T04:23:49.850Z",
  },
  {
    _id: "65d6cc558845c39895773f21",
    title: "VEGE FRESH SPRING ROLLS",
    price: 20,
    desc: "Tofu, pickled salad, lettuce with rice vermicelli wrapped in rice paper with house-made peanut dipping sauce.",
    image: "",

    category: "65d6c0d704261474450578b9",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.852Z",
    updatedAt: "2024-02-22T04:23:49.852Z",
  },
  {
    _id: "65d6cc558845c39895773f1c",
    title: "CHICKEN FRESH SPRING ROLLS",
    price: 13,
    desc: " Chicken, pickle salad, lettuce with rice vermicelli wrapped in rice paper house-made sweet, garlic fish sauce dipping.",
    image: "",

    category: "65d6c0d704261474450578b9",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.850Z",
    updatedAt: "2024-02-22T04:23:49.850Z",
  },
  {
    _id: "65d6cc558845c39895773f1d",
    title: "PRAWN & PORK DEEP FRIED SPRING ROLLS",
    price: 13,
    desc: "Prawn and pork crispy rice paper spring rolls served with house-made sweet garlic fish sauce.",
    image: "https://saigonstar.s3.ap-southeast-2.amazonaws.com/sringroll2.webp",

    category: "65d6c0d704261474450578b9",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.851Z",
    updatedAt: "2024-02-22T04:23:49.851Z",
  },
  {
    _id: "65d6cc558845c39895773f23",
    title: "CRISPY CHICKEN",
    price: 20.0,
    desc: "Deep-fried chicken served with sweet chili sauce.",
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/CRISPYCHICKEN_590x.webp",

    category: "65d6c0d704261474450578b9",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.852Z",
    updatedAt: "2024-02-22T04:23:49.852Z",
  },
  {
    _id: "65d6cc558845c39895773f33",
    title: "CRISPY SQUID",
    price: 21,
    desc: "Deep fried squid served with sweet chilli sauce.",
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/CRISPYSQUID_590x.webp",

    category: "65d6c0d704261474450578b9",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.853Z",
    updatedAt: "2024-02-22T04:23:49.853Z",
  },

  {
    _id: "65d6cc558845c39895773f30",
    title: "SAIGON STAR FRESH ROLLS",
    price: 13,
    desc: "SAIGON STAR Fishcake, egg, deep-fried spring rolls, pork, pickled salad, and lettuce with rice vermicelli wrapped in rice paper with house-made sweet garlic fish sauce dipping.",
    category: "65d6c0d704261474450578b9",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.853Z",
    updatedAt: "2024-02-22T04:23:49.853Z",
  },
  {
    _id: "65d6cc558845c39895773f29",
    title: "VIETNAMESE PANCAKE",
    price: 21,
    desc: "Savoury crisped pancake filled with bean sprout and onion, with your choice of prawn & pork or chicken, served with house-made sweet, garlic fish sauce.",
    subdesc: ["Chicken", "Prawn & Pork"],
    image: "https://saigonstar.s3.ap-southeast-2.amazonaws.com/pancake.webp",

    category: "65d6c0d704261474450578b9",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.853Z",
    updatedAt: "2024-02-22T04:23:49.853Z",
  },
  ///// canh soup
  {
    _id: "65d6cc558845c39895773f24",
    title: "SPICY TOM YUM SEAFOOD SOUP",
    price: 17,
    desc: "Tom Yum flavoured soup with seafood of squid, fishcake, prawn, mussels, scallops and  bean sprout.",
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/TOMYUMSOUP_590x.webp",
    category: "65d6c0d704261474450578b8",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.852Z",
    updatedAt: "2024-02-22T04:23:49.852Z",
  },
  {
    _id: "65d6cc558845c39895773f25",
    title: "CHICKEN MUSHROOM SOUP",
    price: 11,
    desc: "A light chicken and mushroom gravy soup.",
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/CHICKENMUSHROOMSOUP_590x.webp",
    category: "65d6c0d704261474450578b8",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.852Z",
    updatedAt: "2024-02-22T04:23:49.852Z",
  },
  //goi - salad
  {
    _id: "65d6cc558845c39895773f3a",
    title: "SPICY BEEF SALAD",
    price: 25,
    desc: "Spicy beef with a thinly sliced pickled salad of carrot, cabbage, capsicum, ginger, cucumber, onion served with roasted peanuts and house-made sweet lemon dressing.",
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/BEEFSALAD_590x.webp",
    category: "65d6c0d704261474450578bc",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.854Z",
    updatedAt: "2024-02-22T04:23:49.854Z",
  },
  {
    _id: "65d6cc558845c39895773f40",
    title: "CHICKEN SALAD",
    price: 24,
    desc: "Shredded chicken in a thinly sliced pickled salad of carrot, cabbage, capsicum, ginger, cucumber, onion served with roasted peanuts and house-made sweet lemon dressing.",
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/CHICKENSALAD_590x.webp",
    category: "65d6c0d704261474450578bc",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.855Z",
    updatedAt: "2024-02-22T04:23:49.855Z",
  },
  {
    _id: "65d6cc558845c39895773f2b",
    title: "TOFU SALAD",
    price: 21,
    desc: "Tofu with a thinly sliced pickled salad of carrot, cabbage, capsicum, ginger, cucumber, onion served with roasted peanuts and house-made sweet lemon dressing.",
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/TOFUSALAD_590x.webp",
    category: "65d6c0d704261474450578bc",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.853Z",
    updatedAt: "2024-02-22T04:23:49.853Z",
  },
  //bun cha ko co
  //pho
  {
    _id: "65d6cc558845c39895773f30",
    title: "BEEF PHO",
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/IMG_0295_590x.webp",
    price: 21,
    desc: "Medium rare beef and beansprouts in steaming hot beef pho rice noodle broth.",
    category: "65d6c0d704261474450578b6",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.853Z",
    updatedAt: "2024-02-22T04:23:49.853Z",
  },
  {
    _id: "65d6cc558845c39895773f33",
    title: "CHICKEN PHO",
    price: 20,
    desc: "Chicken & bean sprouts in steaming chicken pho rice noodle broth. ",
    image: "https://saigonstar.s3.ap-southeast-2.amazonaws.com/chickenpho.webp",
    category: "65d6c0d704261474450578b6",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.854Z",
    updatedAt: "2024-02-22T04:23:49.854Z",
  },
  {
    _id: "65d6cc558845c39895773f35",
    title: "VEGE PHO",
    price: 19,
    desc: "Tofu, broccoli, carrots, tomato, mushrooms and bean sprouts in steaming pho rice noodle broth.",
    image: "https://saigonstar.s3.ap-southeast-2.amazonaws.com/vegepho.webp",
    category: "65d6c0d704261474450578b6",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.854Z",
    updatedAt: "2024-02-22T04:23:49.854Z",
  },
  {
    _id: "65d6cc558845c39895773f36",
    title: "SEAFOOD PHO",
    price: 22,
    desc: "Squid, fishcake, prawn, mussels, scallops and  bean sprout in steaming pho rice noodle broth",
    image: "https://saigonstar.s3.ap-southeast-2.amazonaws.com/seafoodpho.webp",
    category: "65d6c0d704261474450578b6",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.854Z",
    updatedAt: "2024-02-22T04:23:49.854Z",
  },
  // hu tieu xao
  {
    _id: "65d6cc558845c39895773f2a",
    title: "CHICKEN LEMONGRASS & CHILLI STIR FRY RICE NOODLE",
    price: 20,
    desc: "Stir fry rice noodle with chicken lemongrass & chili.",
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/CHICKENSTIRFRIEDEGGNOODLES_590x.webp",
    category: "65d6c0d704261474450578ba",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.853Z",
    updatedAt: "2024-02-22T04:23:49.853Z",
  },
  {
    _id: "65d6cc558845c39895773f20",
    title: "SATAY STIR FRY RICE NOODLE",
    price: 20,
    desc: "Stir fry chicken satay rice noodle with roasted nuts",
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/CHICKENSATAYRICENOODLE_590x.webp",
    category: "65d6c0d704261474450578ba",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.851Z",
    updatedAt: "2024-02-22T04:23:49.851Z",
  },
  {
    _id: "65d6cc558845c39895773f22",
    title: "STIR FRY EGG NOODLE",
    price: 20,
    desc: "Stir fry egg noodle with your choice of chicken, tofu, pork & beef.",
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/CHICKENSTIRFRYRICENOODLE_590x.webp",
    subdesc: ["Chicken", "Pork", "Beef", "Tofu"],
    category: "65d6c0d704261474450578ba",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.852Z",
    updatedAt: "2024-02-22T04:23:49.852Z",
  },
  {
    _id: "65d6cc558845c39895773f1e",
    title: "STIR FRY RICE NOODLE",
    price: 23,
    desc: "Stir fry rice noodle with your choice of either; chicken, tofu, pork or beef.",
    image: "",
    subdesc: ["Chicken", "Pork", "Beef", "Tofu"],
    category: "65d6c0d704261474450578ba",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.851Z",
    updatedAt: "2024-02-22T04:23:49.851Z",
  },
  {
    _id: "65d6cc558845c39895773f1f",
    title: "VIETNAMESE CRISPY NOODLE",
    price: 21,
    desc: "Stir fry chicken, pork and beef with veges on a bed of crispy egg noodle. ",
    subdesc: ["Chicken", "Pork", "Beef", "Tofu"],

    category: "65d6c0d704261474450578ba",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.851Z",
    updatedAt: "2024-02-22T04:23:49.851Z",
  },

  ////
  {
    _id: "65d6cc558845c39895773f2d",
    title: "FRIED RICE",
    price: 19,
    desc: "Fried rice with your choice of either; chicken, tofu, pork or beef.",
    subdesc: ["Chicken", "Pork", "Beef", "Tofu"],
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/CHICKENFRIEDRICE_590x.webp",

    category: "65d6c0d704261474450578bb",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.853Z",
    updatedAt: "2024-02-22T04:23:49.853Z",
  },
  {
    _id: "65d6cc558845c39895773f2e",
    title: "HOMETOWN FRIED RICE,",
    price: 20,
    desc: "Special Vietnamese fried crispy rice with fresh garlic, ginger, chilli, onion and your choice of chicken, pork or prawn.",
    subdesc: ["Chicken", "Pork", "Beef", "Tofu"],
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/HOMETOWNFRIEDRICE_590x.webp",
    category: "65d6c0d704261474450578bb",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.853Z",
    updatedAt: "2024-02-22T04:23:49.853Z",
  },
  {
    _id: "65d6cc558845c39895773f31",
    title: "VIETNAMESE COMBINATION FRIED RICE",
    price: 21,
    desc: "Fied rice with a combination of chinese pork sausage, prawns, & BBQ pork. ",
    image: "https://saigonstar.s3.ap-southeast-2.amazonaws.com/comtam.webp",
    category: "65d6c0d704261474450578bb",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.853Z",
    updatedAt: "2024-02-22T04:23:49.853Z",
  },

  {
    _id: "65d6cc558845c39895773f38",
    title: "GRILLED PORK & EGG ON STEAM RICE",
    price: 21,
    desc: "Vietnamese grilled pork on rice with a  sunny side up egg plated with a side of salad and a bowl of soup served with house-made sweet garlic fish sauce.   ",
    category: "65d6c0d704261474450578bb",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.854Z",
    updatedAt: "2024-02-22T04:23:49.854Z",
  },
  //////////////// Ga - chicken

  {
    _id: "65d6cc558845c39895773f2f",
    title: "CHICKEN LEMONGRASS AND CHILLI",
    price: 25,
    desc: "A stir fry chili chicken with lemongrass onion and garlic.",
    category: "67791248cc320ae6162019f7",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.853Z",
    updatedAt: "2024-02-22T04:23:49.853Z",
  },
  {
    _id: "65d6cc558845c39895773f32",
    title: "CHICKEN VEGE CASHEW NUT",
    price: 26,
    desc: "A light stir fry garlic chicken with veges and roast cashew nuts. ",
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/CHICKENVEGECASHEWNUTS_590x.webp",
    category: "67791248cc320ae6162019f7",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.854Z",
    updatedAt: "2024-02-22T04:23:49.854Z",
  },
  {
    _id: "65d6cc558845c39895773f34",
    title: "CHICKEN COCONUT MUSHROOM",
    price: 26,
    desc: "Creamy coconut chicken with mushrooms, capsicum, onion, and carrots garnished with roasted peanuts.",
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/CHICKENCOCONUTMUSHROOM_590x.webp",
    category: "67791248cc320ae6162019f7",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.854Z",
    updatedAt: "2024-02-22T04:23:49.854Z",
  },
  {
    _id: "65d6cc558845c39895773f39",
    title: "SPICY GRILLED CHICKEN",
    price: 25,
    desc: "Grilled marinated chicken with Saigon Star BBQ sauce.",
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/GRILLEDCHICKEN_590x.webp",
    category: "67791248cc320ae6162019f7",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.854Z",
    updatedAt: "2024-02-22T04:23:49.854Z",
  },
  ////////////////////////Beef
  {
    _id: "65d6cc558845c39895773f37",
    title: "BEEF COCONUT MUSHROOM",
    price: 28,
    desc: "Creamy coconut beef with mushrooms, capsicum, onion, and carrots garnished with roasted peanuts. ",
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/BEEFCOCONUTMUSHROOM_590x.webp",
    category: "67791248cc320ae6162019f8",
    operator: "65d6b639bb1369f6006dd3ee",
    __v: 0,
    createdAt: "2024-02-22T04:23:49.854Z",
    updatedAt: "2024-02-22T04:23:49.854Z",
  },
  {
    _id: "67a8e8ac70dbfd10965f1746",
    title: "BEEF SATE",
    price: 27,
    desc: "Beef with Vietnamese chili sate with onion, carrot, capsicum, and celery.",
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/BEEFSATE_590x.webp",
    category: "67791248cc320ae6162019f8",
    operator: "65d6b639bb1369f6006dd3ee",
    createdAt: "2025-02-09T17:41:00.325Z",
    updatedAt: "2025-02-09T17:41:00.325Z",
    __v: 0,
  },
  {
    _id: "67a8e8ac70dbfd10965f1747",
    title: "BEEF LEMONGRASS & CHILLI",
    price: 27,
    desc: "A stir fry chilli beef  with lemongrass  onion and garlic",
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/BEEFLEMONGRASS_CHILLI_590x.webp",
    category: "67791248cc320ae6162019f8",
    operator: "65d6b639bb1369f6006dd3ee",
    createdAt: "2025-02-09T17:41:00.325Z",
    updatedAt: "2025-02-09T17:41:00.325Z",
    __v: 0,
  },
  {
    _id: "67a8e8ac70dbfd10965f1748",
    title: "Tomato Beef",
    price: 27,
    desc: "Ribeye cut of diced beef and veges with a tangy tomato base",
    category: "67791248cc320ae6162019f8",
    operator: "65d6b639bb1369f6006dd3ee",
    createdAt: "2025-02-09T17:41:00.325Z",
    updatedAt: "2025-02-09T17:41:00.325Z",
    __v: 0,
  },
  {
    _id: "67a8e8ac70dbfd10965f1749",
    title: "Beef Green Pepper",
    price: 28,
    desc: "Beef with capsicum, carrot, onion and green pepper sauce",
    category: "67791248cc320ae6162019f8",
    operator: "65d6b639bb1369f6006dd3ee",
    createdAt: "2025-02-09T17:41:00.325Z",
    updatedAt: "2025-02-09T17:41:00.325Z",
    __v: 0,
  },
  {
    _id: "67a8e8ac70dbfd10965f1750",
    title: "Roasted Garlic Beef",
    price: 27,
    desc: "Beef with roasted garlic, onions and capsicum with black pepper sauce base",
    category: "67791248cc320ae6162019f8",
    operator: "65d6b639bb1369f6006dd3ee",
    createdAt: "2025-02-09T17:41:00.325Z",
    updatedAt: "2025-02-09T17:41:00.325Z",
    __v: 0,
  },

  //pork 67791248cc320ae6162019f9
  {
    _id: "67a8e8ac70dbfd10965f1751",
    title: "SWEET AND SOUR PORK",
    price: 27,
    desc: "Battered fried marinated pork with a sweet & sour base with tomato, pineapple, capsicum, carrot, celery, and onion.",
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/SWEET_SOURPORK_295x.avif",
    category: "67791248cc320ae6162019f9",
    operator: "65d6b639bb1369f6006dd3ee",
    createdAt: "2025-02-09T17:41:00.325Z",
    updatedAt: "2025-02-09T17:41:00.325Z",
    __v: 0,
  },
  {
    _id: "67a8e8ac70dbfd10965f1752",
    title: "5 SPICED PORK",
    price: 25,
    desc: "Stir fry pork with five spice garlic sauce with capsicum, onion, carrot & celery.",
    category: "67791248cc320ae6162019f9",
    operator: "65d6b639bb1369f6006dd3ee",
    createdAt: "2025-02-09T17:41:00.325Z",
    updatedAt: "2025-02-09T17:41:00.325Z",
    __v: 0,
  },
  {
    _id: "67a8e8ac70dbfd10965f1753",
    title: "Rock Salt Garlic Chilli Pork",
    price: 24,
    desc: "Deepfried pork shacked in a special chilli garlic rock salt with spring onions",
    category: "67791248cc320ae6162019f9",
    operator: "65d6b639bb1369f6006dd3ee",
    createdAt: "2025-02-09T17:41:00.325Z",
    updatedAt: "2025-02-09T17:41:00.325Z",
    __v: 0,
  },
  // hai san 67791248cc320ae616201910
  {
    _id: "67a8e8ac70dbfd10965f1754",
    title: "SALT & GARLIC CHILLI PRAWNS",
    price: 30,
    desc: "King prawns  shacked in special chilli garlic rock salt with spring onions.",
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/PRWAN_GARLICCHILLI_590x.webp",
    category: "67791248cc320ae616201910",
    operator: "65d6b639bb1369f6006dd3ee",
    createdAt: "2025-02-09T17:41:00.325Z",
    updatedAt: "2025-02-09T17:41:00.325Z",
    __v: 0,
  },
  {
    _id: "67a8e8ac70dbfd10965f1755",
    title: "SALT & PEPPER SQUID",
    price: 29,
    desc: "Salt & Pepper with garlic & onion squid.",
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/SALT_PEPPERSQUID_590x.webp",
    category: "67791248cc320ae616201910",
    operator: "65d6b639bb1369f6006dd3ee",
    createdAt: "2025-02-09T17:41:00.325Z",
    updatedAt: "2025-02-09T17:41:00.325Z",
    __v: 0,
  },
  {
    _id: "67a8e8ac70dbfd10965f1756",
    title: "PRAWN CHILLI & GARLIC",
    price: 30,
    desc: "Stir fry king prawns with chilli and garlic sauce.",
    category: "67791248cc320ae616201910",
    operator: "65d6b639bb1369f6006dd3ee",
    createdAt: "2025-02-09T17:41:00.325Z",
    updatedAt: "2025-02-09T17:41:00.325Z",
    __v: 0,
  },

  // do chay 67791248cc320ae616201911
  {
    _id: "67a8e8ac70dbfd10965f1757",
    title: "TOFU LEMONGRSSS AND CHILLI",
    price: 25,
    desc: "Tofu  stir fry chilli with lemongrass  onion and garlic",
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/TOFULEMONGRASSCHILLIRICENOODLE_590x.webp",
    category: "67791248cc320ae616201911",
    operator: "65d6b639bb1369f6006dd3ee",
    createdAt: "2025-02-09T17:41:00.325Z",
    updatedAt: "2025-02-09T17:41:00.325Z",
    __v: 0,
  },
  {
    _id: "67a8e8ac70dbfd10965f1758",
    title: "TOFU VEGE CASHEW NUT",
    price: 26,
    desc: "A light stir fry garlic tofu with veges and roast cashew nuts.",
    category: "67791248cc320ae616201911",
    operator: "65d6b639bb1369f6006dd3ee",
    createdAt: "2025-02-09T17:41:00.325Z",
    updatedAt: "2025-02-09T17:41:00.325Z",
    __v: 0,
  },
  {
    _id: "67a8e8ac70dbfd10965f1759",
    title: "STIR FRY MIXED VEGE GARLIC SAUCE",
    price: 21,
    desc: "Stir fry mixed vege of broccoli, capsicum, cauliflower, onion, and carrots with garlic sauce. ",
    image:
      "https://saigonstar.s3.ap-southeast-2.amazonaws.com/TOFUVEGE_590x.webp",
    category: "67791248cc320ae616201911",
    operator: "65d6b639bb1369f6006dd3ee",
    createdAt: "2025-02-09T17:41:00.325Z",
    updatedAt: "2025-02-09T17:41:00.325Z",
    __v: 0,
  },
  {
    _id: "67a8e8ac70dbfd10965f1760",
    title: "GREEN VEGE IN GARLIC",
    price: 20,
    desc: "Stir fry bok choy with garlic sauce. ",
    category: "67791248cc320ae616201911",
    operator: "65d6b639bb1369f6006dd3ee",
    createdAt: "2025-02-09T17:41:00.325Z",
    updatedAt: "2025-02-09T17:41:00.325Z",
    __v: 0,
  },
];
